import './index.scss';
import * as React from 'react';

export default class BottomBar extends React.Component {
  state = {
    visible: true,
  };

  componentDidMount() {
    this.props.on('show', this.show);
    this.props.on('hide', this.hide);
  }

  show = () => this.setState({ visible: true });

  hide = () => this.setState({ visible: false });

  onClickButton = () => {
    this.props.emit('clickButton');
  };

  static isPriceTitle = text =>
    text.indexOf('￥') > -1 ||
    text.indexOf('¥') > -1 ||
    text.indexOf('元') > -1;

  static renderFixedText = (text, color) => {
    const style = { color };

    // ￥99 or ￥9/4节
    const match = text.match(/([￥¥])?(\d+\.?\d*)(元)?([/|\\]\d*\s*节)?/);
    if (!match || !BottomBar.isPriceTitle(match[0])) {
      return (
        <div className="bottom-bar-title" style={style}>
          {text}
        </div>
      );
    }

    const [, priceTag = '', price = '', unit1 = '', unit2 = ''] = match;
    const title1 = text.slice(0, match.index);
    const title2 = text.slice(match.index + match[0].length);
    return (
      <div className="bottom-bar-title" style={style}>
        {title1}
        <span className="bottom-bar-title-price-tag">{priceTag}</span>
        <span className="bottom-bar-title-price">{price}</span>
        <span className="bottom-bar-title-price-unit">{`${unit1}${unit2}`}</span>
        {title2}
      </div>
    );
  };

  render() {
    const {
      data: { buttonText, titleText, subTitleText },
      style: {
        buttonColor,
        titleColor,
        subTitleColor,
        buttonTextColor,
        bgColor,
      },
    } = this.props;

    const withoutSubTitle = !subTitleText;

    return (
      <div
        className={`fudao-bottom-bar ${
          this.state.visible ? 'visible' : 'hidden'
        }`}
        style={{ backgroundColor: bgColor }}
      >
        <div className={withoutSubTitle ? 'without-sub-title' : ''}>
          {BottomBar.renderFixedText(titleText, titleColor)}
          <div
            className="bottom-bar-sub-title"
            style={{ color: subTitleColor }}
          >
            {subTitleText || ''}
          </div>
        </div>
        {buttonText ? (
          <button
            style={{ color: buttonTextColor, backgroundColor: buttonColor }}
            onClick={this.onClickButton}
          >
            {buttonText}
          </button>
        ) : null}
      </div>
    );
  }
}
